<template>
  <div class="quick-topic-wrap" v-if="quickTopicInfo.coverImgPc">
    <img
      class="cover"
      :src="quickTopicInfo.coverImgPc"
      :alt="quickTopicInfo.name"
      @click="goToQuickTopic"
    />
  </div>
</template>

<script>
export default {
  props: {
    quickTopicInfo: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    goToQuickTopic() {
      let url = "";
      if (this.quickTopicInfo.urls) {
        url = this.quickTopicInfo.urls.pc;
      }
      if (url) {
        setTimeout(() => {
          window.location.href = url;
        });
      }
    },
  },
  name: "QuickTopic",
};
</script>

<style lang="scss" scoped>
.quick-topic-wrap {
  img {
    width: 620px;
    height: 413px;
  }
  cursor: pointer;
}
</style>
